import swipe from 'jquery-touchswipe';

export default class Actions {
    scrollUp() {
        $('.btn-up').click(function(e) {
          e.preventDefault();

          $('html, body').animate({
            scrollTop: 0
          }, 500);
        });
    }

    scrollToAnchor() {
      $(document).on('click', 'a[href^="#"]', function (e) {
        e.preventDefault();
        if ($.attr(this, 'href') != '#') {
          $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 120
          }, 500);
        }
      });
    }

    navToggler() {
      let toggler = document.querySelector('.btn-nav');
      toggler.addEventListener('click', () => {
        document.body.classList.toggle('nav-toggled')
      });

      // $('.menu-item-has-children span').click(function(e) {
      //   e.preventDefault();
      //   $(this).parent().find('.submenu').toggleClass('active');
      // });
    }


    // video() {
    //   $('.box-video button').click(function(e) {
    //     var $box = $(this).parents('.box-video');
    //     e.preventDefault();

    //     $box.find('.box-video__poster').hide();
    //     $box.find('video').trigger('play');
    //   })
    // }

    faq() {
      $('.faq-el__header').click(function() {
        $(this).parent().toggleClass('active');
      })
    }


    offerChar() {

      $('.offer-char').swipe({
        swipeLeft:function(event, direction, distance, duration, fingerCount) {
          var index = $('.offer-char__item.active').index();

          if($('.offer-char__item.active').is(':last-child')) {
            index = $('.offer-char__item:first-child').index();
          }
          else {
            index++;
          }

          $('.offer-char__item').removeClass('active');
          $('.offer-char__item').eq(index).addClass('active');
          $('.offer-char-pagination__item').removeClass('active');
          $('.offer-char-pagination__item').eq(index).addClass('active');
        },
        swipeRight:function(event, direction, distance, duration, fingerCount) {
          var index = $('.offer-char__item.active').index();

          if($('.offer-char__item.active').is(':first-child')) {
            //index = 0;
            index = $('.offer-char__item:last-child').index();
          }
          else {
            index--;
          }

          $('.offer-char__item').removeClass('active');
          $('.offer-char__item').eq(index).addClass('active');
          $('.offer-char-pagination__item').removeClass('active');
          $('.offer-char-pagination__item').eq(index).addClass('active');
        },
      }
      );

      $('.offer-char-pagination__item').click(function() {
        var index = $(this).index();
        $('.offer-char-pagination__item').removeClass('active');
        $(this).addClass('active');
        
        $('.offer-char__item').removeClass('active');
        $('.offer-char__item').eq(index).addClass('active');

      });
    }


    toc() {
      $('.sp__text').find('h2, h3, h4, h5, h6').each(function( index ) {
        var id = "toc_" + index;
        $(this).attr('id', id);
  
        var $el = '<li><a href="#' + id + '">' + $(this).text() + '</a></li>';
        $('#toc_list').append($el);
      });
  
    }


    galleryFilter() {
      $('#expand_gallery_filter').click(function() {
        $('.gallery-filter').show();
        $('.gallery-filter-expand').hide();
      });

      $('#toggle_gallery_filter').click(function() {
        $('.gallery-filter').hide();
        $('.gallery-filter-expand').show();
      });
    }


    mobile() {
      $('.menu__link').click(function() {
        $(this).parent().toggleClass('active');
      })
    }
  
    init() {
      document.querySelector('.btn-up') ? this.scrollUp() : null;
      document.querySelector('#nav_mobile') ? this.mobile() : null;
      document.querySelector('.hamburger') ? this.navToggler() : null;
      document.querySelector('.offer-char') ? this.offerChar() : null;
      document.querySelector('.faq-list') ? this.faq() : null;
      document.querySelector('.sp__text') ? this.toc() : null;
      document.querySelector('.gallery-filter') ? this.galleryFilter() : null;
      this.scrollToAnchor();
    }
}
